export default [6000, 10000, 7500, 4000, 3500, 5500, 6000];
